import { render, staticRenderFns } from "./BMenuGroup.vue?vue&type=template&id=6b1a2edf&scoped=true&"
import script from "./BMenuGroup.vue?vue&type=script&lang=js&"
export * from "./BMenuGroup.vue?vue&type=script&lang=js&"
import style0 from "./BMenuGroup.vue?vue&type=style&index=0&id=6b1a2edf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1a2edf",
  null
  
)

export default component.exports